import { P2GGrid } from '@parcel2go/core-ui';
import { P2GCheckBoxLegacy } from '@parcel2go/core-ui';
import { P2GChip } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  toggle: (val: boolean) => void;
  selected: number;
  total: number;
  source?: string;
  provider?: string;
  isXs: boolean;
  children?: React.ReactNode;
}

const QuickSelectOption: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GGrid container alignItems="center" spacing={1}>
      <P2GGrid item flexGrow={1}>
        <P2GCheckBoxLegacy
          checked={props.selected == props.total}
          onChange={props.toggle}
          id="Checkbox"
          label={
            <P2GText variant="body2">
              {props.children}
              {!props.isXs && (
                <>
                  <br />
                  <P2GText variant="body2">
                    {t('QUICK_SELECT_OPTION_LABEL', {
                      defaultValue: '{{selected}} / {{total}} Selected',
                      selected: props.selected,
                      total: props.total
                    })}
                  </P2GText>
                </>
              )}
            </P2GText>
          }
          labelPlacement="end"
          variant="primary"
          error={false}
        />
      </P2GGrid>
      {props.isXs && (
        <P2GGrid item flexShrink={1}>
          <P2GChip
            label={t('QUICK_SELECT_OPTION_LABEL', {
              defaultValue: '{{selected}} / {{total}} Selected',
              selected: props.selected,
              total: props.total
            })}
            size="small"
            color="primary"
          />
        </P2GGrid>
      )}
    </P2GGrid>
  );
};
export default QuickSelectOption;
